module.exports = __webpack_public_path__ + "static/media/close.f462bb1d.svg";